import React, { useEffect, useState } from "react";
import {Button, Modal, Tab} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import ModalControls from "../../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../../defaults/Forms";
import {zusRateDefault} from "../../../../../defaults/Items";
import Tabs from 'react-bootstrap/Tabs';

import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../../common/LoadingDataDiv";
import DeleteWarningModal from "../../../common/DeleteWarningModal";
import SettingsEntityModal from "../../../common/SettingsEntityModal";
import TextInput from "../../../../elements/TextInput";
import TextArea from "../../../../elements/TextArea";
import useCrud from "../../../../../hooks/useCrud";
import { Table } from "../../../../table/Table";

import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import Toggler from "../../../../elements/Toggler";
import NumberInput from "../../../../elements/NumberInput";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import QDatePicker from "../../../../elements/QDatePicker";
import TabEmployeePersonalData from "../../employees/TabEmployeePersonalData";
import NumberInputNested from "../../../../elements/NumberInputNested";


const ZusRate = () => {

  const dataUrl = "/zus-rates";
  const accidentBranchesUrl = "/zus-accident-branches";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = zusRateDefault;
  const itemName = "Wysokość składek";
  const itemNames = "wysokości składek";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);
  const [activeTab, setActiveTab] = useState("zus-basics");
  const [defaultAccidentBranch, setDefaultAccidentBranch] = useState(null);

  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Skrócona nazwa", accessor: "shortName", sortable: true, searchable: true},
    {label: "Opis", accessor: "description", sortable: true, searchable: true},
    {label: "Rok", accessor: "year", sortable: true, searchable: true},
    {label: "Obowiązuje od", accessor: "validFrom", sortable: true, searchable: true},
    {label: "Obowiązuje do", accessor: "validTo", sortable: true, searchable: true},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }

  const [validFrom, setValidFrom] = useState(state.currentItem.validFrom);
  const [validTo, setValidTo] = useState(state.currentItem.validTo);

  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }

  const onOptionalPercentageChange = (propertyName, rawValue) => {
    const value = rawValue === "" ? null : Number(rawValue);
    setCurrentItem(item => ({...item, [propertyName]: value}));
    setItemChanged(changed => !changed);
    setCurrentFormState(form => ({...form, formSaveButtonDisabled: false}));
  };

  const optionalPercentageValue = (value) => value === "" || value == null ? null : Number(value);

  const optionalPercentageInput = (propertyName) => (
    <input
      type="number"
      id={propertyName}
      name={propertyName}
      min="0"
      max="999"
      step="0.01"
      value={currentItem[propertyName] ?? ""}
      className="form-control"
      onChange={(event) => onOptionalPercentageChange(propertyName, event.target.value)}
    />
  );

  const onSaveItemClick = async (e) => {
    e.preventDefault();
    if (!currentItem.name || !currentItem.shortName) {
      if (!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
      }

      if (!currentItem.shortName) {
        let shortNameInput = document.getElementById("shortName");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }
      return;
    }

    let response;
    const item = {
      id: currentItem.id,
      shortName: currentItem.shortName,
      name: currentItem.name,
      description: currentItem.description,
      year: currentItem.year,
      validFrom: currentItem.validFrom,
      validTo: currentItem.validTo,
      retirement: currentItem.retirement,
      disability: currentItem.disability,
      employerRetirement: optionalPercentageValue(currentItem.employerRetirement),
      employerDisability: optionalPercentageValue(currentItem.employerDisability),
      krusEmployerContributionPercent: optionalPercentageValue(currentItem.krusEmployerContributionPercent),
      studentPupilEmployerContributionPercent: optionalPercentageValue(currentItem.studentPupilEmployerContributionPercent),
      sickness: currentItem.sickness,
      defaultAccidentRate: optionalPercentageValue(currentItem.defaultAccidentRate),
      accidentRates: currentItem.accidentRates,
      health: currentItem.health,
      labourFund: currentItem.labourFund,
      solidarity: currentItem.solidarity,
      guaranteedEmployeeBenefits: currentItem.guaranteedEmployeeBenefits,
      retirementDisabilityCap: currentItem.retirementDisabilityCap, // 30-krotność prognozowanego przeciętnego wynagrodzenia (8669 × 30)
      otherLimit: currentItem.otherLimit,
      averageSalary: currentItem.averageSalary, // prognozowane przeciętne wynagrodzenie 2025 (60% = 5200 zł)
      minSalary: currentItem.minSalary, // minimalne wynagrodzenie od 1.01.2025
      minHealthBase: currentItem.minHealthBase, // 75% minimalnego (podstawa zdrowotna)
      smallZusBase: currentItem.smallZusBase


    };
    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);

    } else {
      response && onSaveAndClose({state});
    }
  }

  useEffect(() => {
    setValidFrom(state.currentItem.validFrom ? new Date(state.currentItem.validFrom) : null);
    setValidTo(state.currentItem.validTo ? new Date(state.currentItem.validTo) : null);
  }, [state.currentItem]);


  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }


  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };


  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])


  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])


  useEffect(() => {
    const getData = async () => {
      const [response, branchesResponse] = await Promise.all([
        getItems(dataUrl),
        getItems(accidentBranchesUrl)
      ]);

      if (response.status === 200 && branchesResponse.status === 200) {
        setItems(response.data);
        setDefaultAccidentBranch(
          branchesResponse.data.find(branch => branch.active && branch.defaultBranch) || null
        );
        setLoading(false);
      } else if (response.status === 401 || response.status === 403 || branchesResponse.status === 401 || branchesResponse.status === 403) {
        navigate('/login', {state: {from: location}, replace: true})
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      const item = response.data;
      const converted = {
        ...item,
        validFrom: item.validFrom ? new Date(item.validFrom) : null,
        validTo: item.validTo ? new Date(item.validTo) : null
      };
      return converted;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nowe wysokości składek ZUS`
  }



  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }
  return (
    <div id="layoutSidenav_content" className="settings-entity-page">
      <AppComponentCardHeader title="Wysokości składek ZUS" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <SettingsEntityModal
        show={currentFormState.showForm}
        onClose={onClose}
        title={currentFormState.formAddingDataMode ? "Nowa pozycja: Zestaw stawek ZUS" : `Edycja: ${currentItem.name || "Zestaw stawek ZUS"}`}
        adding={currentFormState.formAddingDataMode}
        introText="Zestaw stawek przechowuje wartości obowiązujące w danym roku i okresie. Dane te wpływają na wyliczanie kosztu pracownika."
        onRestore={() => { setUpdateConflict(false); restoreFormData({state}); }}
        onDelete={onDelete}
        onSubmit={onSaveItemClick}
        state={state}
        size="xl"
      >
        <form id="add-zusRate-form" name="add-zusRate-form" className="settings-form-content-card">

                            <div className="row form-group mb-1">
                              <div className="col-md-3 form-label">
                                <label htmlFor="name" className="">Nazwa *</label>
                              </div>
                              <div className="col-md-9">
                                <TextInput propertyName="name" required={true} state={ state }/>
                              </div>
                            </div>
                            <div className="row form-group mb-1">
                              <div className="col-md-3 form-label">
                                <label htmlFor="shortName" className="">Skrót *</label>
                              </div>
                              <div className="col-md-2">
                                <TextInput propertyName="shortName" maxlen="10" required={true} state={state}/>
                              </div>
                            </div>
                            <div className="row form-group mb-1">
                              <div className="col-md-3 form-label">
                                <label htmlFor="description" className="">Opis</label>
                              </div>
                              <div className="col-md-9">
                                <TextArea propertyName="description" required={false} rows="2" state={state}/>
                              </div>
                            </div>
                            <div className="row form-group mb-1">
                              <div className="col-md-3 form-label">
                                <label htmlFor="year" className=""><span className="required">*</span> Rok obowiązywania</label>
                              </div>
                              <div className="col-md-2">
                                <TextInput propertyName="year" maxlen="10" required={true} state={state}/>
                              </div>
                            </div>

                            <div className="row form-group mb-1">
                              <div className="col-md-3 form-label">
                                <label htmlFor="validFrom" className=""><span className="required">*</span> Obowiązuje od</label>
                              </div>
                              <div className="col-md-2">
                                <QDatePicker
                                  pickerId="validFrom"
                                  errorParagraphId="wrongValidFromFormat"
                                  state={state}
                                  propertyName="validFrom"
                                  startDate={validFrom ? new Date(validFrom) : null}
                                  setStartDate={setValidFrom}
                                />
                                <p id="wrongValidFromFormat" className={"err_info offscreen"}>
                                  <FontAwesomeIcon icon={faInfoCircle}/>&nbsp; Nieprawidłowy format daty
                                </p>
                              </div>
                            </div>
                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="validTo" className=""><span className="required">*</span> Obowiązuje do</label>
                              </div>
                              <div className="col-md-2">
                                <QDatePicker
                                  pickerId="validTo"
                                  errorParagraphId="wrongValidToFormat"
                                  state={state}
                                  propertyName="validTo"
                                  startDate={validTo ? new Date(validTo) : null}
                                  setStartDate={setValidTo}
                                />
                                <p id="wrongValidToFormat" className={"err_info offscreen"}>
                                  <FontAwesomeIcon icon={faInfoCircle}/>&nbsp; Nieprawidłowy format daty
                                </p>
                              </div>
                            </div>

                            <Tabs
                              activeKey={activeTab}
                              onSelect={(k) => setActiveTab(k)}
                              id="zus"
                              className="mb-3"
                            >
                              <Tab eventKey="zus-limits" title="Prognozy i limity">

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="retirementDisabilityCap" className=""><span className="required">*</span> Limit dla składek emerytalno-rentowych</label>
                                  </div>
                                  <div className="col-md-4 d-flex align-items-center">
                                    <NumberInput propertyName="retirementDisabilityCap" defaultValue="0" min="0.0" max="99999" required="true" state={state}/>
                                    <div className="form_tooltip"><FontAwesomeIcon icon={faQuestionCircle}/><span
                                      className="form_tooltip_text">Górny limit podstawy wymiaru dla składek emerytalno-rentowych. 30-krotność prognozowanego przeciętnego wynagrodzenia</span></div>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="averageSalary" className=""><span className="required">*</span> Prognozowane wynagrodzenie</label>
                                  </div>
                                  <div className="col-md-4 d-flex align-items-center">
                                    <NumberInput propertyName="averageSalary" defaultValue="0" min="0.0" max="99999" required="true" state={state}/>
                                    <div className="form_tooltip"><FontAwesomeIcon icon={faQuestionCircle}/><span
                                      className="form_tooltip_text">Prognozowane przeciętne wynagrodzenie w danym roku</span></div>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="minSalary" className=""><span className="required">*</span> Minimalne wynagrodzenie</label>
                                  </div>
                                  <div className="col-md-4 d-flex align-items-center">
                                    <NumberInput propertyName="minSalary" defaultValue="0" min="0.0" max="99999" required="true" state={state}/>
                                    <div className="form_tooltip"><FontAwesomeIcon icon={faQuestionCircle}/><span
                                      className="form_tooltip_text">Minimalne wynagrodzenie w danym roku</span></div>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="minHealthBase" className=""><span className="required">*</span> Minimalna podstawa zdrowotna</label>
                                  </div>
                                  <div className="col-md-4 d-flex align-items-center">
                                    <NumberInput propertyName="minHealthBase" defaultValue="0" min="0.0" max="99999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="smallZusBase" className=""><span className="required">*</span> Podstawa dla tzw. „małego ZUS-u”</label>
                                  </div>
                                  <div className="col-md-4 d-flex align-items-center">
                                    <NumberInput propertyName="smallZusBase" defaultValue="0" min="0.0" max="99999" required="true" state={state}/>
                                  </div>
                                </div>

                              </Tab>


                              <Tab eventKey="zus-basics" title="Stawki składek">

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="retirement" className="">Składka emerytalna (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="retirement" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="disability" className="">Składka rentowa (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="disability" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="employerRetirement" className="">Część pracodawcy — emerytalna (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    {optionalPercentageInput("employerRetirement")}
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="employerDisability" className="">Część pracodawcy — rentowa (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    {optionalPercentageInput("employerDisability")}
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="krusEmployerContributionPercent" className="">Koszt pracodawcy KRUS (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    {optionalPercentageInput("krusEmployerContributionPercent")}
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="studentPupilEmployerContributionPercent" className="">Koszt pracodawcy uczeń/student (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    {optionalPercentageInput("studentPupilEmployerContributionPercent")}
                                  </div>
                                  <div className="col-md-5 form-label">
                                    <small>Wspólna roczna stawka kosztowa dla statusu ucznia i studenta.</small>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="sickness" className="">Składka chorobowa (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="sickness" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="defaultAccidentRate" className="">Składka wypadkowa (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    {optionalPercentageInput("defaultAccidentRate")}
                                  </div>
                                  <div className="col-md-5 form-label">
                                    {defaultAccidentBranch ? (
                                      <small>Domyślna branża: {defaultAccidentBranch.name} ({defaultAccidentBranch.code}). Zapis tej wartości tworzy lub aktualizuje stawkę wypadkową dla tej branży i okresu zestawu ZUS.</small>
                                    ) : (
                                      <small className="err_info">Brak aktywnej domyślnej branży wypadkowej. Najpierw ustaw ją w słowniku Branże wypadkowe ZUS.</small>
                                    )}
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="health" className="">Składka zdrowotna (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="health" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="labourFund" className="">Fundusz pracy (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="labourFund" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="solidarity" className="">Fundusz Solidarnościowy (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="solidarity" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="guaranteedEmployeeBenefits" className="">Fundusz Gwar. Św. Pracowniczych (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="guaranteedEmployeeBenefits" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                                <div className="row form-group mb-1">
                                  <div className="col-md-3 form-label">
                                    <label htmlFor="solidarity" className="">Fundusz Solidarnościowy (%)</label>
                                  </div>
                                  <div className="col-md-2">
                                    <NumberInput propertyName="solidarity" defaultValue="3" min="0.0" max="999" required="true" state={state}/>
                                  </div>
                                </div>

                              </Tab>

                              <Tab eventKey="zus-accident" title="Stawki składek za ubezpieczenie wypadkowe">

                                {state.currentItem.accidentRates?.map((rate, index) => (
                                  <div key={rate.id} className="row form-group mb-1">
                                    <div className="col-md-6 form-label">
                                      <label htmlFor={`accidentRates.${index}.rate`}>
                                        {rate.zusAccidentBranch.name} ({rate.zusAccidentBranch.code})
                                      </label>
                                    </div>
                                    <div className="col-md-2">
                                      <NumberInputNested
                                        propertyName={`accidentRates.${index}.rate`}
                                        min="0.0"
                                        max="999"
                                        required="true"
                                        state={state}
                                      />
                                    </div>
                                  </div>
                                ))}

                              </Tab>

                            </Tabs>

                            <p id="conflict_notification" className={updateConflict ? "err_info" : "offscreen"}>
                              <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;
                              Nie można dodać ani zmienić tego elementu, ponieważ istnieje już wpis o tej nazwie i/lub skrócie
                            </p>
                          </form>
      </SettingsEntityModal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );
}

export default ZusRate;
